<div nz-row class="login-box" nzType="flex" nzJustify="center">
  <nz-card [nzBordered]="true" nzTitle="" class="form-first-card">
    <h1 class="text">{{ "app.login.resetpassword" | translate }}</h1>
    <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm()">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="errorTplPassword">
          <nz-input-group [nzPrefix]="prefixLock" [nzSuffix]="passwordsuffix">
            <input
              nzSize="large"
              [type]="passwordVisible ? 'text' : 'password'"
              nz-input
              formControlName="password"
              placeholder="{{ 'app.label.new-password' | translate }}"
            />
          </nz-input-group>
          <ng-template #errorTplPassword let-control>
            <ng-container *ngIf="control.hasError('required')">
              {{ "app.signup.password.required" | translate }}
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control [nzErrorTip]="errorTplCpassword">
          <nz-input-group [nzPrefix]="prefixLock" [nzSuffix]="passwordsuffix">
            <input
              nzSize="large"
              [type]="passwordVisible ? 'text' : 'password'"
              nz-input
              formControlName="cpassword"
              placeholder="{{ 'app.label.cpassword' | translate }}"
            />
          </nz-input-group>
          <ng-template #errorTplCpassword let-control>
            <ng-container *ngIf="control.hasError('required')">
              {{ "app.signup.password.required" | translate }}
            </ng-container>
            <ng-container *ngIf="control.hasError('NoPassswordMatch')">
              {{ "app.signup.password.validation.mismatch" | translate }}
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control>
          <button
            nzSize="large"
            class="mb-lg"
            nz-button
            [nzType]="'primary'"
            [nzBlock]="true"
            [nzLoading]="loading"
            (click)="resetPassword()"
          >
            {{ "app.login.updatepassword" | translate }}
          </button>
        </nz-form-control>
      </nz-form-item>
    </form>
    <ng-template #prefixLock>
      <!--<span
        nz-tooltip
        nzTitle="{{ 'app.signup.password.required' | translate }}"
      >
        <i nz-icon nzType="lock"></i>
      </span>-->
    </ng-template>
    <ng-template #passwordsuffix>
      <i
        nz-icon
        [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
        (click)="passwordVisible = !passwordVisible"
      ></i>
    </ng-template>
  </nz-card>
</div>
